import { render, staticRenderFns } from "./SetInvoiceVatPeriod.yaml?vue&type=template&id=df4380b0&component"
import script from "./SetInvoiceVatPeriod.yaml?vue&type=script&lang=ts&component"
export * from "./SetInvoiceVatPeriod.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports